"use client";

import { useEffect, useState } from "react";

// Height below which the sidebar footer nav collapses into the account dropdown.
export const SHORT_VIEWPORT_MAX_HEIGHT = 768;

const QUERY = `(max-height: ${SHORT_VIEWPORT_MAX_HEIGHT - 0.02}px)`;

export const useIsShortViewport = (): boolean => {
  const [isShort, setIsShort] = useState(false);

  useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const update = () => setIsShort(mql.matches);
    update();
    mql.addEventListener("change", update);
    return () => mql.removeEventListener("change", update);
  }, []);

  return isShort;
};
